import { render, staticRenderFns } from "./TaskPageComments.vue?vue&type=template&id=43f5a416&"
import script from "./TaskPageComments.vue?vue&type=script&lang=js&"
export * from "./TaskPageComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports